import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/storefront/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/context-i18n/src/lib/context-i18n.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/address-form/address-form.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/address-select/address-select.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/americanexpress.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/applePayMark.svg");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/creditCard.svg");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/discover.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/mastercard.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/assets/images/visa.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/cart-menu/cart-menu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/checkout/delivery-section.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/checkout/order-summary.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/checkout/table-section.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/confetti/confetti.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/delivery-pickup-toggle/delivery-pickup-toggle.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/delivery-tracker/delivery-tracker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/discount-coupon/discount-coupon.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/estimated-wait/estimated-wait.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/low-tip-modal/low-tip-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheckoutLoyalty"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/loyalty-status/checkout-loyalty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompleteLoyalty"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/loyalty-status/complete-loyalty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnrollmentCard3D"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/loyalty-status/enrollment-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoyaltyCard3D"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/loyalty-status/loyalty-card-3d.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/loyalty-status/loyalty-status.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu-item/menu-item-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCartButton"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu-item/menu-item-details/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModifierGroupView"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu-item/menu-item-details/modifier-group-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecialInstructions"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu-item/menu-item-details/special-instructions.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu-item/menu-item.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/menu/menu-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoyaltyNavBadge"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/navbar/loyalty-nav-badge.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/navbar/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/opening-hours/opening-hours.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeliveryOrder"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-complete/complete-delivery-order.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PickupOrder"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-complete/complete-pickup-order.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOrder"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-complete/complete-table-order.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderHistoryCard"] */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-history/order-history-card.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-item-list/order-item-list.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-schedule/order-schedule.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-totals/order-totals.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/order-user/order-user.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/payment-method-form/payment-method-form.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/payment-method/payment-method.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/places/places-autocomplete.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/places/places-provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/reward-modal/reward-modal.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/table-select/table-select.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/ui-state-context/ui-state-context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-storefront/src/lib/user-menu/user-menu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/assets/avocado.svg");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/CheckmarkButton/checkmark-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/close-icon/close-icon.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/code-input/code-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/currency-input/currency-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/date-picker/date-picker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/dropdown/dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/dropzone-area/dropzone-area.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/expandable-text/expandable-text.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/file-upload/file-upload.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/hooks/use-controllable-state.ts");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-crop/image-crop.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-upload/image-upload.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-with-fallback/image-with-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/inline-auth/inline-auth.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/label/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedLogo"] */ "/opt/render/project/src/libs/ui-system-next/src/lib/loading/animated-logo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/map/map.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/modal/modal.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/page-nav/page-nav.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/phone-input/phone-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/selection-group/selection-group.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/tabs/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/time-input/time-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/tip-selector/tip-selector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/url-bar/url-bar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/user-menu/user-menu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/wizard/wizard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Portal","Overlay","Content","Title","Description","Root","Trigger","Action","Cancel"] */ "/opt/render/project/src/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
